import { Add, Button, Clickable, Col, Game, LiveBadge, Row, Text } from 'components';
import { formatLocale, theme, updateTypes } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const GameItem = ({ item, admin, fullWid, onClick, dontShowGamePage }) => {
  const { sport, type, league, winner, home, away, score, progress, gameStatus } = item;

  const [visible, setVisible] = useState(false),
    [modalVisible, setModalVisible] = useState(false),
    { t } = useTranslation(),
    dispatch = useDispatch(),
    date = new Date(item.date),
    updateType = updateTypes.find((x) => x.opt === type),
    isLive = item.status === 'live';

  if (!home) return null;

  function handleVisible() {
    if (onClick) return onClick();

    setVisible(!visible);
  }

  function handleShoutout() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: true
      }
    });
  }

  return (
    <React.Fragment>
      <Clickable onClick={handleVisible} disabled={admin} ogOpacity>
        <Col noFlex ht="207px" wid={fullWid ? '100%' : '296px'} bg={theme.SECONDARY}>
          <Col pad="16px" start between wid="calc(100% - 32px)">
            <Col noFlex wid="100%">
              <Row between wid="100%">
                <Text c1 bold col="#fff" wid="75%">
                  {league}
                </Text>

                {isLive && <LiveBadge progress={progress} gameStatus={gameStatus} sport={sport} />}
              </Row>

              <Row start>
                <Text
                  col="#fff"
                  b1
                  bold={!winner || item.winner === 'home'}
                  marg="8px 0 0"
                  maxWid="45%"
                >
                  {home.name}
                </Text>

                <Text col="#fff" b1 bold marg="8px 4px 0">
                  -
                </Text>

                <Text
                  col="#fff"
                  b1
                  bold={!winner || item.winner === 'away'}
                  marg="8px 0 0"
                  maxWid="45%"
                >
                  {away.name}
                </Text>
              </Row>

              <Text col="#fff" b2 marg="4px 0 0">
                {item.location}
              </Text>
            </Col>

            <Col noFlex wid="100%">
              <Col ht="40px" noFlex centerAll bg={theme.SECONDARY_60} hasRadius="48px" wid="100%">
                <Text med col="#fff">
                  {isLive || item.status === 'finished' ? (
                    <Row center>
                      <Text b2 med col="#fff">
                        {score.home} : {score.away}
                      </Text>
                    </Row>
                  ) : (
                    formatLocale(date, 'MMM d, k:mm a')
                  )}
                </Text>
              </Col>

              <Button
                marg="8px 0 0"
                icon="shoutoutOutline"
                iconSize={22}
                text={t('common.shoutout')}
                onClick={(e) => {
                  setModalVisible(true);

                  if (!e) e = window.event;
                  e.cancelBubble = true;
                  if (e.stopPropagation) e.stopPropagation();
                }}
              />
            </Col>
          </Col>
        </Col>
      </Clickable>

      {!admin && !dontShowGamePage && (
        <Game ev={item} visible={visible} closeModal={handleVisible} />
      )}

      <Add
        visible={modalVisible}
        setVisible={setModalVisible}
        preSelectData={{
          eventObject: item
        }}
        preSelect={2}
        preSelectPage="shoutoutGame"
      />
    </React.Fragment>
  );
};

export default GameItem;
